import React from 'react';
import TableRow from '@mui/material/TableRow';
import TableCell from '@mui/material/TableCell';
import Skeleton from '@mui/material/Skeleton';

export interface TableSkeletonProps {
  rows?: number;
  columnWidths: Array<number | string>;
}


const TableSkeleton: React.FC<TableSkeletonProps> = ({ rows = 8, columnWidths }) => {
  return (
    <>
      {Array.from({ length: rows }).map((_, rowIdx) => (
        <TableRow key={`skeleton-${rowIdx}`}> 
          {columnWidths.map((width, colIdx) => (
            <TableCell key={colIdx}>
              <Skeleton variant="text" width={width} />
            </TableCell>
          ))}
        </TableRow>
      ))}
    </>
  );
};

export default TableSkeleton;
